<template>
  <div id="aboutus">
    <div class="container-fluid">
      <div class="row main-content">
        <div class="col-sm-12 col-md-9">
          <div class="text-main-container" data-aos="fade-down">
            <div class="small-title">
              <h4 v-html="state.historyHome.title"></h4>
              <hr>
            </div>
            <div class="text-container">
              <h1 v-html="state.historyHome.subTitle"></h1>
              <br>
              <p style="max-width:500px;">{{ state.historyHomepTextTop }}</p>

              <p style="max-width:500px;"> {{ state.historyHome.pTextBottom }} </p>
              <div style="transform:skew(10deg);">
                <router-link to="/nosotros" tag="a">{{ state.historyHome.btnText }}</router-link>
              </div>

            </div>
          </div>
          <div class="truck-img-contqainer" data-aos="fade-right">
            <img width="100%" src="../../assets/imgs/home_foto3_roja.png">
          </div>
        </div>
        <div class="col-md-3 display-none-minres" style="text-align:left;" data-aos="fade-left">
          <img src="../../assets/imgs/home_foto2.png" width="100%">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  methods: {
  },
  components: {
  },
  computed: {
    state() {
      return this.$store.state.activeList
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';


.main-content {
  display: block;
  color: $gris;
  height: 100%;
}

.text-main-container {
  padding: 150px;
}

.truck-img-contqainer {
  text-align: left;
  width: 90%;
}

.img-container {
  position: absolute;
  color: white;
  right: 0px;
  height: 100%;
  min-height: 0%;
  background-image: url(../../assets/imgs/home_foto2.png);
}

h4 {
  color: $gris;
  display: inline-block;
}

hr {
  display: inline-block;
  vertical-align: middle;
  height: 2px;
  border: 0;
  width: 30%;
  border-top: 2px solid $rojo;
  margin: 1em 1em;
  padding: 0;
}

a {
  position: relative;
  text-decoration: none;
  color: white;
  background-color: $rojo;
  padding: 10px;
  top: 20px;
  width: 150px;
  height: 100px;
  -webkit-transform: skew(20deg);
  -moz-transform: skew(20deg);
  -o-transform: skew(20deg);
}

.floating-text {
  text-align: right;
  margin-top: 30%;
  margin-left: -21%;
  position: absolute;
  width: 250px;
}

.floating-text hr {
  display: inline-block;
  vertical-align: middle;
  height: 2px;
  border: 0;
  width: 30%;
  border-top: 2px solid $azul;
  margin: 1em 1em;
  padding: 0;
}

h1 {
  color: $azul;
  font-size: 40pt;
}

.text-container {
  text-align: left;
  margin-top: 5%;
}

.text-container p {
  font-size: 15pt;
}

.small-title {
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width:1000px) {
  .img-container {
    display: none;
  }

  .text-main-container {
    padding: 40px;
  }

  h1 {
    font-size: 30pt;
  }
  .display-none-minres {
    display: none;
  }
  h4 {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// HistoryPage.vue?05433fe5